<template>
  <div class="content">
    <msg-menu></msg-menu>

    <div class="tabs messages-tabs-content">
      <div class="lists-tab-content  clearfix">
        <div class="search-list">
          <div class="search">
            <input class="input-sm" v-model="searchFilter" type="text" placeholder="Search by List Name">
          </div>
          <a class="btn btn-sm btn-plus"
             v-on:click.prevent="isEditListModal = true;listInfo=null"
             href="#"
          ><span class="plus-icon"></span>Create List</a>
        </div>

        <div class="all-lists-wrap" v-if="listsLoaded">

          <div v-if="listsFiltered.length<1"
               v-on:click.prevent="isEditListModal = true"
               class="d-block d-block-list shadow-md d-list-close">
            <div class="list-header">
              <div class="list-inf-param">
                <h3 class="filter-list-name">No Lists Yet</h3>
                <p class="desc">Organize contacts into lists such as "Board Members", "Volunteers, etc.</p>
              </div>
            </div>
          </div>

          <div v-else
               v-for="(list, index) in listsFiltered"
               :key="index"
               v-on:click.prevent="goToList(list, $event)"
               class="d-block d-block-list shadow-md d-list-close">

            <div class="list-header">
              <div class="row">
                <div class="col-md-6">
                  <div class="list-inf-param">
                    <h3 class="filter-list-name">{{list.name}}</h3>
                    <p class="desc">{{list.description}}</p>
                  </div>
                </div>
                <div class="col-md-6 list-r-info">
                  <div class="list-inf-param">
                    <div class="val list-member-count">{{list.member_count}}</div>
                    <div class="desc">Contacts</div>
                  </div>
                  <div class="list-inf-param">
                    <div class="val">{{list.messages_sent}}</div>
                    <div class="desc">Messages Sent</div>
                  </div>

                  <div class="dropdown">
                    <span class="input-select-wrap"
                    ><button class="dropbtn" :data-dropdown="`.select-list-${list.id}`">Options</button></span>
                    <div :class="`dropdown-content dropdown-right select-list-${list.id}`">
                      <router-link :to="{name: 'ContactsList', params: {listId: list.id}}">View List</router-link>
                      <a href="#" v-if="list.member_count" v-on:click.prevent="goToMsgSend(list)">Send Message</a>
                      <a href="#" v-on:click.prevent="isAddUsersListModal = true;listInfo = list">Add Users</a>
                      <a href="#" v-on:click.prevent="isEditListModal = true;listInfo = list">Rename</a>
                      <a href="#" v-on:click.prevent="isDeleteListModal = true;listInfo = list">Delete</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="isDeleteListModal && listInfo"
           :listInfo="listInfo"
           v-on:close-modal="isDeleteListModal = false"
           v-on:deleted="isDeleteListModal = false; updateLists()"
           :modal-name="'delete-list'"></modal>

    <modal v-if="isEditListModal"
           :listInfo="listInfo"
           v-on:close-modal="isEditListModal = false"
           v-on:saved="isEditListModal = false; updateLists();"
           :modal-name="'list-modal'"></modal>

    <modal v-if="isAddUsersListModal && listInfo"
           :listInfo="listInfo"
           v-on:close-modal="isAddUsersListModal = false"
           v-on:updated="isAddUsersListModal = false; updateLists();"
           :modal-name="'list-add-users'"></modal>

  </div>
</template>

<script>
  import {getLists} from '@/utils/api';
  import MsgMenu from './menu.vue';
  import Modal from '../Modal/index.vue';
  import {mapState} from "vuex";

  export default {
    name: 'Lists',
    metaInfo: {
      title: 'Messages - Lists',
    },
    mounted() {
      this.updateLists();
      this.isCreatePage();
    },
    components: {
      MsgMenu,
      Modal,
    },
    methods: {
      isCreatePage: function() {
        if(this.$route.query && this.$route.query.create){
          this.isEditListModal = true;
          let query = Object.assign({}, this.$route.query);
          delete query.create;
          this.$router.replace({query});
        }
      },
      goToMsgSend: function(list) {
        this.$router.push({name: 'messagesNew', query: {'list_id': list.id}});
      },
      goToList: function(list, e) {
        if(!e.target.closest('.dropdown')){
          this.$router.push({name: 'ContactsList', params: {listId: list.id}});
        }
      },
      updateLists: function() {
        getLists().then(lists => {

          this.lists = lists;
          this.listsLoaded = true;
        });
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
      }),
      listsFiltered() {
        if (this.searchFilter === '') {
          return [...this.lists].reverse();
        }
        const re = new RegExp(this.searchFilter, 'ig');

        return this.lists.filter(v => v.name.search(re) !== -1).reverse();
      },
    },
    beforeRouteUpdate (to, from, next) {
      this.$nextTick(() => {
        this.isCreatePage();
      });
      next();
    },
    watch: {
      'activeCharityId'() {
        this.lists = [];
        this.listsLoaded = false;
        this.updateLists();
      },
    },
    data() {
      return {
        searchFilter: '',
        isAddUsersListModal: false,
        isEditListModal: false,
        isDeleteListModal: false,
        listInfo: null,
        lists: [],
        listsLoaded: false,
      };
    },
  };
</script>
